import Common, { Settings, SortByEnum, POI_IMAGES, COLORS, isSearchResult, API_BASE_URL } from "../Common/Common";
//import search_green from "../assets/images/search.png";
import search_green from "../assets/icons/search.png";
import default_icon from "../assets/icons/color_purple.png"; //"../assets/images/poi.png";
import { getDistance, getPreciseDistance } from "geolib";
import { DateTime } from "luxon";
import { isSameImage } from "../Common/photoCredit";

export default class Place {
  constructor(places) {
    this.PType = "Icon";
    this.Lat = "";
    this.Longi = "";
    this.Category = [];
    this.Group = [];
    //this.Groups = ["New"];
    //this.Categories = ["New"];
    this.Rating = "";
    this.Favorite = false;
    this.Visited = false;
    this.Info = "";
    this.Photo = "";
    this.Photo_m = "";
    this.ID = "";
    this.Points = null;
    // Set only for a PolyLine Path created/edited via the Directions dialog
    // (DirectionsDialogComponent.js): { from, to: {Name,Lat,Longi,ID?},
    // waypoints: [same shape, in route order], travelMode }. Lets "Edit
    // Directions" reopen that dialog with the original From/Waypoints/To
    // places already filled in, instead of only being able to redraw a
    // path from scratch. null for a path drawn/imported any other way
    // (hand-drawn, KML, WalkAI's own paths).
    this.DirectionsRoute = null;
    this.Address = "";
    this.Country = "";
    this.State = "";
    this.City = "";
    this.Phone = "";
    this.Name = "New";
    this.Open = "";
    this.Hlink = "";
    this.Link = { type: "none", value: "", offset: "0" };
    ///new
    this.Image = "";
    this.Email = "";
    //this.URL = "";
    this.Source = Place_Source.USER;
    this.Hidden = false;
    this.MustSee = false;
    this.BucketList = false;
    this.poi_img = "0";
    // 60, not something shorter — a wrong-but-short guess (e.g. 30 min for a
    // place that actually needs 2 hours) understaffs the schedule and pushes
    // everything after it too early; a wrong-but-long guess just leaves a
    // little slack. Safer to overestimate when there's no real signal at
    // all. Raised from 30 to 60 2026-09-01 — see Common.estimateDurationForTypes's
    // matching fallback.
    this.Duration = 60;
    this.OpeningHours = Place.getDefaultOpeningHours();
    //this.PlaceLink = "none";
    ///Remove???
    //this.Opacity = "";
    // this.thick = "";
    // this.Tag = "";
    // this.Color = "";
    // this.obj = null;
    // this.Level = "None";
    // this.Zone = "None";
    // this.poi = null;
    // this.oneGroup = "New";
    // this.oneCategory = "New";
    // this.POV = "";
    // this.Pop = "";
    let placesList = places;
    if (places == null) {
      if (typeof window !== "undefined") {
        if (window.web_app === true) {
          placesList = window.guide_obj.places;
        }
      }
    }
    if (placesList != null) {
      var r = Math.floor(Math.random() * 1000000000 + 1);
      // getPlace compares with === against .ID, which is always a string —
      // passing the raw Number here made this check silently never match,
      // so every new place accepted its first random draw with zero real
      // collision protection. Same fix as mobile's Place.js.
      while (placesList.getPlace(r.toString()) != null) r = Math.floor(Math.random() * 1000000000 + 1);
      this.ID = r.toString();
    }
  }

  createIDFromPlacesObject(placesArray) {
    var r = Math.floor(Math.random() * 1000000000 + 1);
    // Same string/Number mismatch fix as the constructor above.
    while (placesArray.getPlace(r.toString()) != null) r = Math.floor(Math.random() * 1000000000 + 1);
    this.ID = r.toString();
    return this.ID;
  }

  createIDFromPlacesArray(placesArray) {
    while (true) {
      var r = Math.floor(Math.random() * 1000000000 + 1);
      let found = true;
      for (let i = 0; i < placesArray.length; i++) {
        if (placesArray[i].ID == r) {
          found = false;
          break;
        }
      }
      if (found) {
        this.ID = r.toString();
        return this.ID;
      }
    }
  }

  json_to_place(place_json, oldGuide) {
    //console.log("place_json", place_json);
    this.PType = place_json.PType;
    this.Category = place_json.Category;
    this.Group = place_json.Group;
    //this.Categories = place_json.Categories;
    this.Rating = place_json.Rating;
    if (typeof this.Rating == "undefined") this.Rating = "";
    // this.POV = place_json.POV;
    this.ID = place_json.ID;
    //this.Info = place_json.Info;
    this.Info = place_json.Info; //Common.createTextFromHTML(place_json.Info);
    if (typeof this.Info === "undefined") this.Info = "";
    // this.Pop = place_json.Pop;
    this.Photo = place_json.Photo;
    if (typeof place_json.Photo_m !== "undefined") this.Photo_m = place_json.Photo_m;
    else this.Photo_m = this.Photo;
    if (oldGuide) {
      if (this.Photo.toUpperCase().endsWith("_T.JPG")) {
        let suffix = this.Photo;
        this.Photo = `http://liquidguides.com/Media/Photos/${this.Photo}`;
        this.Photo_m = `http://liquidguides.com/Media/Photos/${suffix.replace("_t", "_m")}`;
      }
      //console.log("this.Photo", this.Photo);
      //console.log("this.Photo_m", this.Photo_m);
    }
    // Temporary fix
    // else if (!this.Photo.startsWith("http") && this.Photo !== "") {
    //   let suffix = this.Photo;
    //   this.Photo = `http://liquidguides.com/Media/Photos/${this.Photo}`;
    //   this.Photo_m = `http://liquidguides.com/Media/Photos/${suffix.replace("_t", "_m")}`;
    // }
    // Temporary fix
    // if (this.Photo === "http://liquidguides.com/Media/Photos/") this.Photo = "";
    // if (this.Photo_m === "http://liquidguides.com/Media/Photos/") this.Photo_m = "";
    // null / NaN (saved by older code) = no location, kept as "".
    this.Lat = place_json.Lat == null || (typeof place_json.Lat === "number" && !Number.isFinite(place_json.Lat)) ? "" : place_json.Lat;
    this.Longi = place_json.Longi == null || (typeof place_json.Longi === "number" && !Number.isFinite(place_json.Longi)) ? "" : place_json.Longi;
    if (typeof this.Lat == "string") this.Lat = parseFloat(this.Lat);
    if (typeof this.Longi == "string") this.Longi = parseFloat(this.Longi);
    this.Points = place_json.Points;
    this.DirectionsRoute = typeof place_json.DirectionsRoute === "undefined" ? null : place_json.DirectionsRoute;
    //this.Opacity = place_json.Opacity;
    this.Address = place_json.Address;
    this.Country = place_json.Country;
    this.State = place_json.State;
    this.City = place_json.City;
    this.Phone = place_json.Phone;
    this.Name = place_json.Name;
    this.Favorite = typeof place_json.Favorite == "undefined" ? false : place_json.Favorite;
    this.Visited = typeof place_json.Visited == "undefined" ? false : place_json.Visited;
    // this.thick = place_json.Thick;
    // this.Tag = place_json.Tag;
    // this.Color = place_json.Color;
    this.Image = place_json.Image;
    this.Open = place_json.Open;
    this.Hlink = place_json.Hlink;
    this.Hidden = typeof place_json.Hidden == "undefined" ? false : place_json.Hidden;
    this.MustSee = typeof place_json.MustSee == "undefined" ? false : place_json.MustSee;
    this.BucketList = typeof place_json.BucketList == "undefined" ? false : place_json.BucketList;
    this.poi_img = typeof place_json.poi_img == "undefined" ? "0" : place_json.poi_img;
    // Some places (e.g. AI-found ones saved before the AISearch.js Duration
    // fix) can have a non-numeric Duration in stored data — a raw string
    // reaching schedule building's DateTime.plus() crashes it, so coerce here.
    this.Duration = Place.parseDuration(place_json.Duration);
    // Nothing usable was stored → the number above is only a filler. Marked
    // so a save can leave it out again (see storageReplacer) instead of
    // writing the filler back as if it had been chosen.
    if (place_json.DurationUnset === true || !Place.hasStoredDuration(place_json.Duration)) this.DurationUnset = true;
    this.OpeningHours = Place.mergeOpeningHoursDefaults(place_json.OpeningHours);
    // Date (YYYY-MM-DD) the hours were last looked up — see
    // GooglePlaces.fetchOpeningHours. Only present once a lookup ran.
    if (place_json.HoursChecked) this.HoursChecked = place_json.HoursChecked;
    // Best time of day to visit — "morning", "afternoon", "sunset" or
    // "evening" — from Create Trip w/AI (2026-10-16); the schedule keeps
    // morning places early and sunset/evening ones late. Absent = any time.
    if (place_json.BestTime) this.BestTime = place_json.BestTime;
    // Stock photo's print-size image and credit (Common/photoCredit.js,
    // 2026-10-17). Absent for the user's own photos.
    if (place_json.PhotoPrint) this.PhotoPrint = place_json.PhotoPrint;
    if (place_json.PhotoCredit) this.PhotoCredit = place_json.PhotoCredit;

    this.Link = place_json.Link =
      typeof place_json.Link === "undefined" ? { type: "none", value: "", offset: "0" } : place_json.Link;
    if (typeof place_json.pathLink !== "undefined")
      this.Link = { type: "path", value: place_json.pathLink, offset: "0" };
    if (typeof place_json.videoLink !== "undefined")
      this.Link = { type: "video", value: place_json.videoLink, offset: "0" };
    if (typeof place_json.videoLinkOffset !== "undefined") this.Link.offset = place_json.videoLinkOffset;

    // if (typeof place_json.pathLink !== "undefined") this.pathLink = place_json.pathLink;
    // if (typeof place_json.videoLink !== "undefined") this.videoLink = place_json.videoLink;
    // if (typeof place_json.videoLinkOffset !== "undefined") this.videoLinkOffset = place_json.videoLinkOffset;

    // if (typeof place_json.audioLink !== "undefined") this.audioLink = place_json.audioLink;
    // if (typeof place_json.sectionLink !== "undefined") this.sectionLink = place_json.sectionLink;
    // if (typeof place_json.videoPLink !== "undefined") this.videoPLink = place_json.videoPLink;
    // if (typeof place_json.PlaceLink !== "undefined") this.placeLink = place_json.PlaceLink;
    // else this.PlaceLink = "none";

    ///////new
    this.Email = "";
    //this.URL = "";
    // this.obj = null;
    // this.Level = "None";
    // this.Zone = "None";
    this.Source = Place_Source.GUIDE;
    // this.poi = null;
    // this.oneGroup = "None";
    // this.oneCategory = "None";

    // if (this.Color == null) this.Color = "255,0,0";
    // else if (this.Color.indexOf(",") == -1) this.Color = "255,0,0";

    // if (this.Opacity == null) this.Opacity = "1";
    // else if (this.Opacity == "") this.Opacity = "1";

    // if (this.Thick == null) this.Thick = "3";
    // else if (this.Thick == "") this.Thick = "3";

    if (this.Category == null || this.Category == "") this.Category = [];
    if (this.Group == null || this.Group == "") this.Group = [];
    else if (this.Group.indexOf(":") != -1) {
      var cats = "";
      var groups = "";
      var gs = this.getGroups();
      for (var j = 0; j < gs.length; ++j) {
        if (gs[j].indexOf("c:") != -1) {
          var parts = gs[j].split(":");
          if (cats != "") cats += "|";
          cats += parts[1];
        } else {
          var parts = gs[j].split(":");
          if (groups != "") groups += "|";
          if (parts.length == 1) groups += parts[0];
          else {
            groups += parts[1];
            // if (parts[0] == "z") this.Zone = parts[1];
            // else if (parts[0] == "l") this.Level = parts[1];
          }
        }
      }
      this.Group = groups;
      this.Category = cats;
    }
    this.getLatlongForPoly();
    // if (this.PType == "PolyLine" || this.PType == "Polygon" || this.PType == "HandDrawing") {
    //   var lat = 0.0;
    //   var lon = 0.0;
    //   var total = 0.0;
    //   var lines = this.getLines();
    //   for (var x = 0; x < lines.length; x++) {
    //     var line = lines[x];
    //     for (var y = 0; y < line.length; y++) {
    //       if (y % 2) {
    //         lon += line[y];
    //         total += 1.0;
    //       } else lat += line[y];
    //     }
    //   }
    //   this.Lat = lat / total;
    //   this.Longi = lon / total;
    // }
  }

  // Duration is meant to be minutes as a bare number, but a bad source (an AI
  // response, an older import) can leave a descriptive string like "90
  // minutes" in stored data — pull out the first number found rather than
  // let it reach Luxon's DateTime.plus() unparsed.
  // What a place gets when its stored data has no Duration at all.
  static UNSET_DURATION = 30;

  static parseDuration(value) {
    if (typeof value === "number" && isFinite(value)) return value;
    const match = typeof value === "string" ? value.match(/\d+(\.\d+)?/) : null;
    return match ? parseFloat(match[0]) : Place.UNSET_DURATION;
  }

  static hasStoredDuration(value) {
    return (typeof value === "number" && isFinite(value)) || (typeof value === "string" && /\d/.test(value));
  }

  // For JSON.stringify(guide, Place.storageReplacer) when a guide is SAVED.
  // A place with no Duration loads as UNSET_DURATION (above) — a filler so
  // the schedulers have a number to work with — and is marked DurationUnset.
  // Saved as-is, that filler was written back as if someone had chosen it:
  // open and save any guide once and every place in it claimed to be a
  // 30-minute visit, permanently (found 2026-10-13: Florence, 35 of 35
  // places). Here the filler is left out again, so "nobody set this" stays
  // distinguishable from a real value. Nothing is guessed from the number
  // itself: a Duration that was really stored — including a real 30 — is
  // always kept, and so is any value set since loading (it no longer equals
  // the filler). The marker itself is never stored.
  static storageReplacer(key, value) {
    if (key === "DurationUnset") return undefined;
    // No location is saved as "" — never null or NaN (JSON writes NaN as
    // null), which made the place editor crash (null.toFixed), including
    // in app versions already released. 2026-10-17.
    if ((key === "Lat" || key === "Longi") && (value === null || (typeof value === "number" && !Number.isFinite(value)))) return "";
    if (key === "Duration" && this && this.DurationUnset === true && value === Place.UNSET_DURATION) return undefined;
    return value;
  }

  static getLatlongForPoly(place) {
    //console.log("getLatlongForPoly1");
    if (place.PType == "PolyLine" || place.PType == "Polygon" || place.PType == "HandDrawing") {
      //console.log("getLatlongForPoly2");
      var lat = 0.0;
      var lon = 0.0;
      var total = 0.0;
      var lines = Place.getLines(place);
      //console.log("getLatlongForPoly3", lines);
      for (var x = 0; x < lines.length; x++) {
        // var line = lines[x];
        // for (var y = 0; y < line.length; y++) {
        lon += lines[x].Longi;
        lat += lines[x].Lat;
        // if (y % 2) {
        //   lon += line[y];
        total += 1.0;
        // } else lat += line[y];
        // }
      }
      place.Lat = lat / total;
      place.Longi = lon / total;
      //console.log("getLatlongForPoly4", place.Lat, place.Longi);
    }
    return place;
  }

  getLatlongForPoly() {
    //console.log("getLatlongForPoly1");
    if (this.PType == "PolyLine" || this.PType == "Polygon" || this.PType == "HandDrawing") {
      //console.log("getLatlongForPoly2");
      var lat = 0.0;
      var lon = 0.0;
      var total = 0.0;
      var lines = this.getLines();
      //console.log("getLatlongForPoly3", lines);
      for (var x = 0; x < lines.length; x++) {
        // var line = lines[x];
        // for (var y = 0; y < line.length; y++) {
        lon += lines[x].Longi;
        lat += lines[x].Lat;
        // if (y % 2) {
        //   lon += line[y];
        total += 1.0;
        // } else lat += line[y];
        // }
      }
      this.Lat = lat / total;
      this.Longi = lon / total;
      //console.log("getLatlongForPoly4", this.Lat, this.Longi);
    }
  }

  getLatlongForPoly() {
    //console.log("getLatlongForPoly1");
    if (this.PType == "PolyLine" || this.PType == "Polygon" || this.PType == "HandDrawing") {
      //console.log("getLatlongForPoly2");
      var lat = 0.0;
      var lon = 0.0;
      var total = 0.0;
      var lines = this.getLines();
      //console.log("getLatlongForPoly3", lines);
      for (var x = 0; x < lines.length; x++) {
        // var line = lines[x];
        // for (var y = 0; y < line.length; y++) {
        lon += lines[x].Longi;
        lat += lines[x].Lat;
        // if (y % 2) {
        //   lon += line[y];
        total += 1.0;
        // } else lat += line[y];
        // }
      }
      this.Lat = lat / total;
      this.Longi = lon / total;
      //console.log("getLatlongForPoly4", this.Lat, this.Longi);
    }
  }

  getLatLongsForPlace() {
    if (this.PType == "Icon") {
      return [{ Lat: this.Lat, Longi: this.Longi }];
    }
    if (this.PType == "PolyLine" || this.PType == "Polygon" || this.PType == "HandDrawing") {
      return this.getLines().flat();
    }
    return [];
  }

  static getLatLongsForPlace(place) {
    if (place.PType === "Icon") {
      return [{ Lat: place.Lat, Longi: place.Longi }];
    }
    if (place.PType == "PolyLine" || place.PType == "Polygon" || place.PType == "HandDrawing") {
      return Place.getLines(place).flat();
    }
    return [];
  }
  static createImagesHTML(imageURLs, fb_path, size, width) {
    let html_doc = "";
    for (let i = 0; i < imageURLs.length; i++) {
      html_doc += Place.createImageHTML(imageURLs[i].url_m, fb_path, size, width);
    }
    return html_doc;
  }

  // Photo_m is often a full-resolution third-party URL that hotlink-blocks
  // (some hosts return 200 with a broken-image body instead of 403, so an
  // <img onerror> never fires) — routing it through this proxy first fetches
  // it server-side, sidestepping the hotlink check, while keeping full
  // resolution (unlike falling back straight to the small Photo thumbnail).
  //
  // But Google's own Places Photo API and Wikimedia are reliable, don't
  // hotlink-block, and don't need this — proxying them anyway just adds an
  // extra failure-prone hop (our own server's timeout/rate limits) with no
  // upside, and was the likely cause of images intermittently falling back
  // to a worse photo despite the real fetch working fine when tested
  // directly. Only proxy genuinely third-party URLs.
  static RELIABLE_IMAGE_HOSTS = ["places.googleapis.com", "wikimedia.org", "gstatic.com"];
  static proxyImageUrl(url) {
    if (!url) return url;
    // "gdrive:<fileId>" isn't a fetchable URL at all — proxying it verbatim
    // (as the fallback below would) sends the proxy an invalid target and
    // produces a broken/placeholder image. Leave it untouched so
    // Common.getImageURL's own gdrive: resolution (into a real
    // lh3.googleusercontent.com URL, itself a reliable host) gets a chance
    // to run — this is called before that resolution, not after.
    if (url.startsWith("gdrive:")) return url;
    if (Place.RELIABLE_IMAGE_HOSTS.some((h) => url.includes(`://${h}`) || url.includes(`.${h}`))) return url;
    return `${API_BASE_URL}/img_proxy.php?url=` + encodeURIComponent(url);
  }

  static createImageHTML(imageURL, fb_path, size, width, photo_fallback) {
    if (width == null) {
      if (size == "medium") width = "600";
      else width = "400";
    }
    const img = Common.getImageURL(imageURL, fb_path, true);
    const photoAttr = (photo_fallback && photo_fallback !== imageURL) ? ` data-photo="${photo_fallback}"` : "";
    const errAttr = ` onerror="window.imgFallback(this)"`;
    // width was previously computed above and then silently discarded here
    // — every inserted image got the same hardcoded max-width:700px
    // regardless of what was picked in HTMLInsertDialog's width picker.
    // Found 2026-10-03 (also present, same bug, in the mobile app's copy).
    const html_doc = `<p style="text-align:center;"><img src="${img}" referrerpolicy="no-referrer" alt="Image" style="width:100%; max-width:${width}px; height:auto; border-radius:10%"${photoAttr}${errAttr}></img></p><br/>`;
    return html_doc;
  }

  // Notes that open with the place's own photo (every Featured guide's do)
  // would show that photo twice in Place Details, which already puts it at
  // the top. Drops that leading image — only when it is the same picture as
  // Photo/Photo_m, and only here: the stored notes are not changed.
  // Added 2026-10-12.
  static stripLeadingOwnPhoto(html, photos) {
    // Notes saved through the HTML editor start with an (often empty)
    // <style> block — look past it, and keep it (2026-10-18).
    const lead = /^(?:\s*<style[^>]*>[\s\S]*?<\/style>)*/i.exec(html)[0];
    const rest = html.slice(lead.length);
    const m = /^(\s*(?:<p[^>]*>\s*)?)<img[^>]*\bsrc=["']([^"']+)["'][^>]*>(?:\s*<\/img>)?(\s*<\/p>)?/i.exec(rest);
    if (!m) return html;
    // The notes' address is HTML: "&amp;" in it is a plain "&".
    const src = m[2].replace(/&amp;/g, "&");
    // The same picture at another size or address counts too (see
    // photoCredit.js sameImageKey).
    if (!photos.filter(Boolean).some((p) => isSameImage(p, src))) return html;
    // A paragraph holding only the image goes with it; one that also holds
    // text keeps its opening tag.
    const keepOpen = !m[3] && /<p/i.test(m[1]);
    return lead + (keepOpen ? m[1] : "") + rest.slice(m[0].length);
  }
  createPlaceDetailsHTML(text, fb_path, guide, scheduledDates) {
    if (this.Name === "undefined") return "";
    let path = this.getPath();
    if (this.PType === "Polygon") {
      const points = path.split("|");
      if (points.length > 2) {
        if (points[1] != points[points.length - 1]) path += "|" + points[1];
      }
    }
    const _staticKey = process.env.REACT_APP_GOOGLE_MAPS_STATIC_API;
    // Ordinary places no longer get a Static Map picture: it was one paid
    // Google request per Place Details view for a small one-pin map, and the
    // "Show on Map" button beside "Place Menu" does the same job. Paths and
    // areas keep theirs — it shows the route/region shape. 2026-10-12.
    let static_map = null;
    if (path != null) {
      static_map = `https://maps.googleapis.com/maps/api/staticmap?size=600x360&maptype=roadmap&path=color:0x2F6FE5ff|weight:4${path}&key=${_staticKey}`;
      if (this.PType == "Polygon") {
        static_map = `https://maps.googleapis.com/maps/api/staticmap?size=600x360&maptype=roadmap&path=fillcolor:0x2F6FE533%7Ccolor:0x2F6FE555|weight:2${path}&key=${_staticKey}`;
      }
    }

    const photoTouse = (this.Photo_m && this.Photo_m !== "") ? Place.proxyImageUrl(this.Photo_m) : this.Photo;
    const img = Common.getImageURL(photoTouse, fb_path, true);

    const css = `
      <style>
        :root {
          --bg: #FAFAFA;
          --surface: #FFFFFF;
          --surface-sunken: #F4F4F5;
          --on-bg: #18181B;
          --on-surface: #18181B;
          --on-surface-muted: #71717A;
          --on-surface-faint: #A1A1AA;
          --border: #E4E4E7;
          --accent: #2F6FE5;
          --radius-lg: 20px;
          --radius-md: 10px;
        }
        * { box-sizing: border-box; }
        html, body {
          margin: 0;
          padding: 0;
          background: var(--bg);
          color: var(--on-bg);
          font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text",
            "Helvetica Neue", Arial, sans-serif;
          font-size: 16px;
          line-height: 1.55;
          -webkit-font-smoothing: antialiased;
        }
        body { padding: 20px 20px 48px; }
        h1 {
          font-size: 28px;
          font-weight: 700;
          letter-spacing: -0.5px;
          margin: 0 0 16px 0;
          color: var(--on-bg);
        }
        .media {
          border-radius: var(--radius-lg);
          overflow: hidden;
          background: var(--surface-sunken);
          margin-bottom: 16px;
        }
        .media img {
          display: block;
          width: 100%;
          height: auto;
          object-fit: cover;
        }
        .map-link { display: block; }
        .description {
          color: var(--on-surface);
          margin: 16px 0;
          font-size: 16px;
        }
        .links {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin: 16px 0 20px;
        }
        .links a {
          display: inline-flex;
          align-items: center;
          padding: 10px 16px;
          background: var(--accent);
          color: #ffffff;
          text-decoration: none;
          border-radius: var(--radius-md);
          font-weight: 600;
          font-size: 14px;
        }
        .links a.secondary {
          background: var(--surface);
          color: var(--on-surface);
          border: 1px solid var(--border);
        }
        .meta {
          background: var(--surface);
          border: 1px solid var(--border);
          border-radius: var(--radius-lg);
          padding: 4px 16px;
          margin-top: 12px;
        }
        .meta-row {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 16px;
          padding: 12px 0;
          border-top: 1px solid var(--border);
        }
        .meta-row:first-child { border-top: 0; }
        .meta-label {
          color: var(--on-surface-muted);
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.6px;
          flex-shrink: 0;
          min-width: 92px;
        }
        .meta-value {
          color: var(--on-surface);
          font-size: 14px;
          text-align: right;
          flex: 1;
          word-break: break-word;
        }
        .meta-value.muted { color: var(--on-surface-faint); }
        .section-title {
          font-size: 11px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.8px;
          color: var(--on-surface-muted);
          margin: 28px 0 8px 4px;
        }
      </style>
    `;

    const escapeHtml = (v) => {
      if (v == null) return "";
      return String(v)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    };
    const displayValue = (v) => {
      const s = (v ?? "").toString().trim();
      if (s === "" || s === "null" || s === "undefined") {
        return '<span class="muted">—</span>';
      }
      return escapeHtml(s);
    };
    const yesNo = (v) => (v === true ? "Yes" : "No");

    const lat = parseFloat(this.Lat);
    const lng = parseFloat(this.Longi);
    const hasCoords = !Number.isNaN(lat) && !Number.isNaN(lng);
    const locationValue = hasCoords
      ? `${lat.toFixed(6)}, ${lng.toFixed(6)}`
      : '<span class="muted">Not applicable</span>';

    const categories = guide.categoryNamesFromIDs(this.Category, ", ") || "";
    const groups = guide.groupNamesFromIDs(this.Group, ", ") || "";

    let infoText = text != null ? text.toString().trim() : "";
    if (img) infoText = Place.stripLeadingOwnPhoto(infoText, [this.Photo_m, this.Photo, this.PhotoPrint]).trim();
    let description = "";
    if (infoText !== "") {
      description = `<div class="description">${infoText.replace(/\n/gi, "<br/>")}</div>`;
    }

    let linksHtml = "";
    if (this.Hlink !== "") {
      const parts = this.Hlink.split(";")
        .map((link) => {
          if (link.includes("|")) {
            const pieces = link.split("|");
            return `<a href="urllink:${escapeHtml(pieces[1])}">${escapeHtml(pieces[0])}</a>`;
          }
          return `<a href="urllink:${escapeHtml(link)}">More information</a>`;
        })
        .filter(Boolean);
      if (parts.length > 0) {
        // A plain "" join relies entirely on this block's own .links{gap}
        // CSS to visually separate multiple links (e.g. a Wikipedia link
        // plus the place's own website) — if this snippet ever renders
        // somewhere that doesn't carry this file's <style> block along with
        // it (a notes editor showing just the HTML fragment, say), adjacent
        // <a> tags with no space between them in the markup itself render
        // flush together with no visible gap at all. A literal space is a
        // harmless no-op wherever the CSS gap already handles it, and the
        // actual fix wherever it doesn't. Found 2026-09-29.
        linksHtml = `<div class="links">${parts.join(" ")}</div>`;
      }
    }

    const formatHHMM = (hhmm) => {
      const [h, m] = hhmm.split(":").map(Number);
      const period = h >= 12 ? "PM" : "AM";
      const h12 = h % 12 === 0 ? 12 : h % 12;
      return `${h12}:${String(m).padStart(2, "0")} ${period}`;
    };
    const openingHoursRows = Place.OPENING_HOURS_DAYS.map((day) => {
      const hours = this.OpeningHours ? this.OpeningHours[day] : null;
      let value;
      if (hours && hours.closed) {
        value = "Closed";
      } else if (hours && Array.isArray(hours.periods) && hours.periods.length > 0) {
        value = hours.periods
          .filter((p) => p.open && p.close)
          .map((p) => `${formatHHMM(p.open)} – ${formatHHMM(p.close)}`)
          .join(", ");
      }
      return `
        <div class="meta-row">
          <span class="meta-label">${day}</span>
          <span class="meta-value">${value ? escapeHtml(value) : '<span class="muted">—</span>'}</span>
        </div>`;
    }).join("");

    let datesHtml = "";
    if (scheduledDates && scheduledDates.length > 0) {
      datesHtml = scheduledDates.map((d) => escapeHtml(d)).join("<br/>");
    } else {
      datesHtml = '<span class="muted">—</span>';
    }

    // "Show on Map" only when there's something to show (2026-10-18): a place
    // without a location (photos without GPS, Wikipedia articles) has none.
    const _lat = parseFloat(this.Lat), _lng = parseFloat(this.Longi);
    const onMap = (Number.isFinite(_lat) && Number.isFinite(_lng) && !(_lat === 0 && _lng === 0)) || ((this.PType === "PolyLine" || this.PType === "Polygon") && !!this.Points);

    return `
      ${css}
      <h1>${escapeHtml(this.Name)}</h1>
      <div class="links" style="margin-bottom:16px;">
        <a class="secondary" href="placemenulink:${this.ID}">Place Menu</a>
        ${onMap ? `<a class="secondary" href="maplink:${this.ID}||">Show on Map</a>` : ""}
      </div>
      ${img ? `<div class="media"><img src="${img}" data-photo="${Common.getImageURL(this.Photo, fb_path, true)}" onerror="window.imgFallback(this)" alt="${escapeHtml(this.Name)}" /></div>` : ""}
      ${static_map ? `<a class="map-link" href="maplink:${this.ID}||">
        <div class="media">
          <img src="${static_map}" alt="Map" />
        </div>
      </a>` : ""}
      ${description}
      ${linksHtml}
      <div class="section-title">Details</div>
      <div class="meta">
        <div class="meta-row">
          <span class="meta-label">Location</span>
          <span class="meta-value">${locationValue}</span>
        </div>
        <div class="meta-row">
          <span class="meta-label">Categories</span>
          <span class="meta-value">${displayValue(categories)}</span>
        </div>
        <div class="meta-row">
          <span class="meta-label">Groups</span>
          <span class="meta-value">${displayValue(groups)}</span>
        </div>
        <div class="meta-row">
          <span class="meta-label">Address</span>
          <span class="meta-value">${displayValue(this.Address)}</span>
        </div>
        <div class="meta-row">
          <span class="meta-label">City</span>
          <span class="meta-value">${displayValue(this.City)}</span>
        </div>
        <div class="meta-row">
          <span class="meta-label">Country</span>
          <span class="meta-value">${displayValue(this.Country)}</span>
        </div>
        <div class="meta-row">
          <span class="meta-label">Phone</span>
          <span class="meta-value">${displayValue(this.Phone)}</span>
        </div>
        <div class="meta-row">
          <span class="meta-label">Email</span>
          <span class="meta-value">${displayValue(this.Email)}</span>
        </div>
        <div class="meta-row">
          <span class="meta-label">Rating</span>
          <span class="meta-value">${displayValue(this.Rating)}</span>
        </div>
      </div>
      <div class="section-title">Flags</div>
      <div class="meta">
        <div class="meta-row">
          <span class="meta-label">Visited</span>
          <span class="meta-value">${yesNo(this.Visited)}</span>
        </div>
        <div class="meta-row">
          <span class="meta-label">Favorite</span>
          <span class="meta-value">${yesNo(this.Favorite)}</span>
        </div>
        <div class="meta-row">
          <span class="meta-label">Must see</span>
          <span class="meta-value">${yesNo(this.MustSee)}</span>
        </div>
        <div class="meta-row">
          <span class="meta-label">Hidden</span>
          <span class="meta-value">${yesNo(this.Hidden)}</span>
        </div>
      </div>
      <div class="section-title">Opening Hours</div>
      <div class="meta">
        ${openingHoursRows}
      </div>
      <div class="section-title">Scheduled</div>
      <div class="meta">
        <div class="meta-row">
          <span class="meta-label">Dates</span>
          <span class="meta-value">${datesHtml}</span>
        </div>
      </div>
    `;
  }

  getFirstHLink() {
    //console.log("this.Hlink", this.Hlink);
    if (this.Hlink == "") return "";
    const links = this.Hlink.split(";");
    if (!links[0].includes("|")) return links[0];
    return links[0].split("|")[1];
  }

  attaction_to_place(attraction_json) {
    this.Source = Place_Source.ATTRACTION;
    this.Lat = attraction_json.latitude;
    this.Longi = attraction_json.longitude;
    this.Name = attraction_json.name;
    //this.Info=attraction_json.description_long; //description_short
    this.Category = attraction_json.categories;
    this.Group = [];
    //this.Image=attraction_json.Image;
    if (attraction_json.photo_t_url == "") this.Photo = window.webSite + "/Icons/place.jpg";
    else this.Photo = window.webSite + "/Attractions/Photos/" + attraction_json.photo_t_url;
    if (attraction_json.photo_m_url == "") this.Photo_m = window.webSite + "/Icons/place.jpg";
    else this.Photo_m = window.webSite + "/Attractions/Photos/" + attraction_json.photo_m_url;
    var wphoto = "";
    if (attraction_json.photo_m_url != null && attraction_json.photo_m_url != "") {
      if (attraction_json.photo_m_width > 320) {
        attraction_json.photo_m_height = attraction_json.photo_m_height * (320 / attraction_json.photo_m_width);
        attraction_json.photo_m_width = 320;
      }
      if (attraction_json.photo_m_height > 480) {
        attraction_json.photo_m_width = attraction_json.photo_m_height * (480 / attraction_json.photo_m_height);
        attraction_json.photo_m_height = 480;
      }
      wphoto = `<img src="${this.Photo_m}" width="${attraction_json.photo_m_width}" height="${attraction_json.photo_m_height}"/>`;
    }
    if (attraction_json.photo_m_url != null && attraction_json.photo_m_url != "") {
      wphoto = `<img src="${this.Photo_m}" width="${attraction_json.photo_m_width}" height="${attraction_json.photo_m_height}"/>`;
    }
    var more_info =
      '<a href="urllink:' +
      window.webSite +
      "/database/get_attraction_description.php?language=1&id=" +
      attraction_json.id +
      '" >More info</a>';
    this.Info =
      "<html><head></head><body><p style='font-size:120%'>" +
      attraction_json.name +
      "<br>" +
      wphoto +
      "<br>" +
      attraction_json.description_short +
      "<br><br>" +
      more_info +
      "</p></body></html>";
  }

  youtube_to_place(youtube_json) {
    this.Source = Place_Source.YOUTUBE;
    this.Lat = youtube_json.geoCoordinates.latitude;
    this.Longi = youtube_json.geoCoordinates.longitude;
    this.Name = youtube_json.title;
    //        if (this.Name=="")
    //            this.Name = "Untitled";
    //        if (this.Name.length > 25)
    //            this.Name = this.Name.substring(0, 24);
    //this.Info=attraction_json.description_long; //description_short
    this.Category = [];
    this.Group = [];
    //this.Image=attraction_json.Image;
    this.Photo = youtube_json.thumbnail.sqDefault;
    this.Photo_m = youtube_json.thumbnail.hqDefault;
    if (this.Photo === "") this.Photo = window.webSite + "/Icons/place.jpg";
    if (this.Photo_m === "") this.Photo_m = window.webSite + "/Icons/place.jpg";
    var wphoto = "";
    if (this.Photo != null && this.Photo != "") {
      wphoto = `<img src="${this.Photo_m} width="480"/>`;
    }
    var videourl = "";
    if (youtube_json.player.mobile != "")
      videourl = '<a href="videolink:' + youtube_json.player.mobile + '" >Play video</span></a>';
    else if (youtube_json.player.default != "")
      //youtube_json.player.default for desktop
      videourl = '<a href="videolink:' + youtube_json.player.default + '" >Play video</span></a>';
    this.Info =
      "<html><head></head><body><p style='font-size:120%'>" +
      youtube_json.title +
      "<br>" +
      wphoto +
      "<br>" +
      videourl +
      "<br>" +
      youtube_json.description +
      "</p></body></html>";
  }

  copy(place) {
    this.Lat = place.Lat;
    this.PType = place.PType;
    this.Category = place.Category;
    this.Rating = place.Rating;
    // this.POV = place.POV;
    //this.ID = place.ID;
    this.Info = place.Info;
    // this.Pop = place.Pop;
    this.Photo = place.Photo;
    if (typeof place.Photo_m == "undefined") this.Photo_m = "";
    else this.Photo_m = place.Photo_m;
    this.Longi = place.Longi;
    this.Points = place.Points;
    //this.Opacity = place.Opacity;
    this.Address = place.Address;
    this.Country = place.Country;
    this.State = place.State;
    this.City = place.City;
    this.Phone = place.Phone;
    this.Name = place.Name;
    this.Group = place.Group;
    // this.thick = place.Thick;
    // this.Tag = place.Tag;
    // this.Color = place.Color;
    this.Image = place.Image;
    this.Open = place.Open;
    this.Hlink = place.Hlink;
    ///////new
    this.Email = place.Email;
    //this.URL = place.URL;
    // this.obj = place.obj;
    // this.Level = place.Level;
    // this.Zone = place.Zone;
    this.Source = place.Source;
    this.Duration = place.Duration;
    this.OpeningHours = Place.mergeOpeningHoursDefaults(place.OpeningHours);
    if (place.HoursChecked) this.HoursChecked = place.HoursChecked;
    else delete this.HoursChecked;
    if (place.BestTime) this.BestTime = place.BestTime;
    else delete this.BestTime;
    if (place.PhotoPrint) this.PhotoPrint = place.PhotoPrint;
    else delete this.PhotoPrint;
    if (place.PhotoCredit) this.PhotoCredit = { ...place.PhotoCredit };
    else delete this.PhotoCredit;

    // this.poi = place.poi;
    // this.oneGroup = place.oneGroup;
    // this.oneCategory = place.oneCategory;
    this.Hidden = typeof place.Hidden == "undefined" ? false : place.Hidden;
    this.MustSee = typeof place.MustSee == "undefined" ? false : place.MustSee;
    this.BucketList = typeof place.BucketList == "undefined" ? false : place.BucketList;
    this.Favorite = typeof place.Favorite == "undefined" ? false : place.Favorite;
    this.Visited = typeof place.Visited == "undefined" ? false : place.Visited;
    this.poi_img = typeof place.poi_img == "undefined" ? "0" : place.poi_img;

    this.Link = place.Link = typeof place.Link === "undefined" ? { type: "none", value: "", offset: "0" } : place.Link;
    if (typeof place.pathLink !== "undefined") this.Link = { type: "path", value: place.pathLink, offset: "0" };
    if (typeof place.videoLink !== "undefined") this.Link = { type: "video", value: place.videoLink, offset: "0" };
    if (typeof place.videoLinkOffset !== "undefined") this.Link.offset = place.videoLinkOffset;

    // if (typeof place.audioLink !== "undefined") this.audioLink = place.audioLink;
    // if (typeof place.sectionLink !== "undefined") this.sectionLink = place.sectionLink;
    // if (typeof place.videoPLink !== "undefined") this.videoPLink = place.videoPLink;
    // if (typeof place.PlaceLink !== "undefined") this.PlaceLink = place.PlaceLink;
  }
  // getLineColor() {
  //   var color = this.Color;
  //   if (color.indexOf(",") == -1) color = "255,0,0";
  //   var opacity = "1";
  //   if (this.Opacity != null) opacity = this.Opacity;
  //   color = "rgba(" + color + "," + opacity.toString() + ")";
  //   return color;
  // }
  // getLineWidth() {
  //   var thickness = "3";
  //   if (this.Thick != null) thickness = this.Thick;
  //   var width = parseInt(thickness);
  //   return width;
  // }

  static getLines(place) {
    //console.log("getLines");
    if (typeof place === "undefined") return [];
    if (typeof place.Points === "undefined") return [];
    var lineList = [];
    var line = [];
    if (place.Points.indexOf(";") !== -1) {
      return this.getCompressedLines(place);
    }
    var lineStrings = [place.Points];
    if (place.Points.indexOf("|") != -1) lineStrings = place.Points.split("|");
    for (var j = 0; j < lineStrings.length; ++j) {
      if (lineStrings[j] == "") continue;
      line = [];
      var points = lineStrings[j].split(":");
      for (var i = 0; i < points.length; ++i) {
        if (points[i] == "") continue;
        if (points[i].indexOf(",") == -1) continue;
        var latLon = points[i].split(",");
        line.push({ Lat: parseFloat(latLon[1]), Longi: parseFloat(latLon[0]) });
        //line.push(parseFloat(latLon[1]));
        //line.push(parseFloat(latLon[0]));
      }
      if (place.PType == "Polygon" && line.length > 1) {
        line.push(line[0]);
        //line.push(line[1]);
      }
      lineList.push(line);
    }
    //}
    //console.log(lineList);
    return lineList;
  }

  static getCompressedLines(place) {
    //console.log("getCompressedLines");
    if (typeof place === "undefined") return [];
    if (typeof place.Points === "undefined") return [];
    //const base62 = require("base62/lib/ascii");
    const geohash = require("ngeohash");
    var lineList = [];
    var line = [];
    var lineStrings = [place.Points];
    if (place.Points.indexOf("|") != -1) lineStrings = place.Points.split("|");
    for (var j = 0; j < lineStrings.length; ++j) {
      if (lineStrings[j] == "") continue;
      line = [];
      var points = lineStrings[j].split(";");
      //console.log(points, points);
      for (var i = 0; i < points.length; ++i) {
        if (points[i] == "") continue;
        if (points[i].indexOf(",") == -1) continue;
        var linePoint = points[i].split(",");
        //console.log('linePoint', linePoint);
        var loc = geohash.decode(linePoint[0]);
        line.push({ Lat: loc.latitude, Longi: loc.longitude });
      }
      if (place.PType == "Polygon" && line.length > 1) {
        line.push(line[0]);
        //line.push(line[1]);
      }
      lineList.push(line);
    }
    //}
    //console.log("line", line);
    return lineList;
  }

  getLines() {
    if (typeof this.Points === "undefined") return [];
    var lineList = [];
    var line = [];
    //if (this.PType == "HandDrawing") {
    var lineStrings = [this.Points];
    if (this.Points.indexOf("|") != -1) lineStrings = this.Points.split("|");
    for (var j = 0; j < lineStrings.length; ++j) {
      if (lineStrings[j] == "") continue;
      line = [];
      var points = lineStrings[j].split(":");
      for (var i = 0; i < points.length; ++i) {
        if (points[i] == "") continue;
        if (points[i].indexOf(",") == -1) continue;
        var latLon = points[i].split(",");
        line.push({ Lat: parseFloat(latLon[1]), Longi: parseFloat(latLon[0]) });
        //line.push(parseFloat(latLon[1]));
        //line.push(parseFloat(latLon[0]));
      }
      if (this.PType == "Polygon" && line.length > 1) {
        line.push(line[0]);
        //line.push(line[1]);
      }
      lineList.push(line);
    }
    //}
    //console.log(lineList);
    return lineList;
  }

  reverseLineDirection = () => {
    if (this.Points == null) return;
    let points_ar = this.Points.split(":");
    let points_ar_rev = points_ar.reverse();
    let new_points = points_ar_rev.join(":");
    this.Points = new_points;
  };

  // getLinesOLD() {
  //   var lineList = [];
  //   //if (this.PType == "HandDrawing") {
  //   var lineStrings = [this.Points];
  //   if (lineStrings.indexOf("|") != -1) lineStrings = this.Points.split("|");
  //   for (var j = 0; j < lineStrings.length; ++j) {
  //     if (lineStrings[j] == "") continue;
  //     var line = [];
  //     var points = lineStrings[j].split(":");
  //     for (var i = 0; i < points.length; ++i) {
  //       if (points[i] == "") continue;
  //       if (points[i].indexOf(",") == -1) continue;
  //       var latLon = points[i].split(",");
  //       line.push(parseFloat(latLon[1]));
  //       line.push(parseFloat(latLon[0]));
  //     }
  //     if (this.PType == "Polygon" && line.length > 1) {
  //       line.push(line[0]);
  //       line.push(line[1]);
  //     }
  //     lineList.push(line);
  //   }
  //   //}
  //   return lineList;
  // }

  getPolyline() {
    //console.log("getPolyline");
    if (this.Points != null) {
      let lineStrings = this.Points;
      if (lineStrings.indexOf(";") !== -1) {
        return this.getCompressedPolyline();
      }
      //A polyline
      if (lineStrings.indexOf("|") == -1) {
        let linePoints = lineStrings.split(":");
        let polyline = [];
        for (let j = 0; j < linePoints.length; ++j) {
          if (linePoints[j] == "") continue;
          if (linePoints[j].indexOf(",") == -1) continue;
          var latLon = linePoints[j].split(",");
          polyline.push({ latitude: parseFloat(latLon[1]), longitude: parseFloat(latLon[0]) });
        }
        return { coordinates: polyline };
      }
    }
    return null;
  }

  static getPolyline(place) {
    //console.log("getPolyline");
    if (place.Points != null) {
      let lineStrings = place.Points;
      if (lineStrings.indexOf(";") !== -1) {
        return Place.getCompressedPolyline(place);
      }
      //A polyline
      if (lineStrings.indexOf("|") == -1) {
        let linePoints = lineStrings.split(":");
        let polyline = [];
        for (let j = 0; j < linePoints.length; ++j) {
          if (linePoints[j] == "") continue;
          if (linePoints[j].indexOf(",") == -1) continue;
          var latLon = linePoints[j].split(",");
          polyline.push({ latitude: parseFloat(latLon[1]), longitude: parseFloat(latLon[0]) });
        }
        return { coordinates: polyline };
      }
    }
    return null;
  }

  getCompressedPolyline() {
    //console.log("getCompressedPolyline");
    if (this.Points != null) {
      //const base62 = require("base62/lib/ascii");
      const geohash = require("ngeohash");
      let lineStrings = this.Points;
      //A polyline
      try {
        if (lineStrings.indexOf("|") == -1) {
          let linePoints = lineStrings.split(";");
          let polyline = [];
          for (let j = 0; j < linePoints.length; ++j) {
            if (linePoints[j] == "") continue;
            if (linePoints[j].indexOf(",") == -1) continue;
            var linePoint = linePoints[j].split(",");
            var loc = geohash.decode(linePoint[0]);
            //var elapsed_time = base62.decode(linePoint[1]);
            polyline.push({ latitude: loc.latitude, longitude: loc.longitude });
          }
          //console.log("polyline", polyline);
          return { coordinates: polyline };
        }
      } catch {
        return null;
      }
    }
    return null;
  }

  static getCompressedPolyline(place) {
    //console.log("getCompressedPolyline");
    if (place.Points != null) {
      //const base62 = require("base62/lib/ascii");
      const geohash = require("ngeohash");
      let lineStrings = place.Points;
      //A polyline
      try {
        if (lineStrings.indexOf("|") == -1) {
          let linePoints = lineStrings.split(";");
          let polyline = [];
          for (let j = 0; j < linePoints.length; ++j) {
            if (linePoints[j] == "") continue;
            if (linePoints[j].indexOf(",") == -1) continue;
            var linePoint = linePoints[j].split(",");
            var loc = geohash.decode(linePoint[0]);
            //var elapsed_time = base62.decode(linePoint[1]);
            polyline.push({ latitude: loc.latitude, longitude: loc.longitude });
          }
          //console.log("polyline", polyline);
          return { coordinates: polyline };
        }
      } catch {
        return null;
      }
    }
    return null;
  }

  getTimedPath() {
    //console.log("getCompressedPolyline", this.Points);
    if (this.Points != null) {
      const base62 = require("base62/lib/ascii");
      const geohash = require("ngeohash");
      let lineStrings = this.Points;
      if (lineStrings.indexOf(";") == -1) return [];
      //A polyline
      try {
        if (lineStrings.indexOf("|") == -1) {
          let linePoints = lineStrings.split(";");
          //let polyline = [];
          let timedPath = [];
          for (let j = 0; j < linePoints.length; ++j) {
            if (linePoints[j] == "") continue;
            if (linePoints[j].indexOf(",") == -1) continue;
            var linePoint = linePoints[j].split(",");
            var loc = geohash.decode(linePoint[0]);
            var elapsed_time = base62.decode(linePoint[1]);
            var altitude = 0;
            if (linePoint.length > 2) {
              altitude = base62.decode(linePoint[2]);
              altitude = altitude / 10.0;
            }
            //polyline.push({ latitude: loc.latitude, longitude: loc.longitude });
            timedPath.push({
              latitude: loc.latitude,
              longitude: loc.longitude,
              elapsed_time: elapsed_time,
              altitude: altitude,
            });
          }
          //console.log("timedPath", timedPath);
          return timedPath;
        }
      } catch {
        return [];
      }
    }
    return [];
  }

  calculateDistance(p1, p2) {
    //console.log("calculateDistance", p1, p2);
    if (p1 == "undefined" || p2 == "undefined") return 0;
    if (p1.latitude == "undefined" || p2.latitude == "undefined") return 0;
    var dis = getDistance(
      { latitude: parseFloat(p1.latitude), longitude: parseFloat(p1.longitude) },
      { latitude: parseFloat(p2.latitude), longitude: parseFloat(p2.longitude) }
    );

    //console.log(p1, p2, dis);
    if (dis == "undefined") return 0;

    //console.log("calculateDistance", dis / 1000);
    return dis / 1000;
  }

  findClosestPointInPath(lat, long) {
    let timed_path = this.getTimedPath();
    let min_distance = 99999999999;
    let min_index = -1;
    for (let i = 0; i < timed_path.length; i++) {
      const p1 = { latitude: lat, longitude: long };
      const p2 = { latitude: timed_path[i].latitude, longitude: timed_path[i].longitude };
      const distance = this.calculateDistance(p1, p2);
      if (distance < min_distance) {
        min_distance = distance;
        min_index = i;
      }
    }
    if (min_index !== -1) return timed_path[min_index];
    else return null;
  }

  findClosestTimeInPath(search_time) {
    let timed_path = this.getTimedPath();
    //console.log("findClosestTimeInPath", search_time);
    let min_time_diff = 99999999999;
    let min_index = -1;
    for (let i = 0; i < timed_path.length; i++) {
      const time_diff = Math.abs(search_time - timed_path[i].elapsed_time);
      if (time_diff < min_time_diff) {
        min_time_diff = time_diff;
        min_index = i;
      }
    }
    if (min_index !== -1) {
      let found = timed_path[min_index];
      found.index = min_index;
      return found;
    } else return null;
  }

  getPath() {
    if (this.Points != null) {
      let lineStrings = this.Points;
      //A polyline
      if (lineStrings.indexOf("|") == -1) {
        if (lineStrings.indexOf(";") !== -1) return this.getCompressedPath();
        let linePoints = lineStrings.split(":");
        let path = "";
        for (let j = 0; j < linePoints.length; ++j) {
          if (linePoints[j] == "") continue;
          if (linePoints[j].indexOf(",") == -1) continue;
          var latLon = linePoints[j].split(",");
          path += "|" + latLon[1] + "," + latLon[0];
        }
        return path;
      }
    }
    return null;
  }

  getKMLPath() {
    if (this.Points != null) {
      let lineStrings = this.Points;
      //A polyline
      if (lineStrings.indexOf("|") == -1) {
        if (lineStrings.indexOf(";") !== -1) return this.getCompressedPath();
        let linePoints = lineStrings.split(":");
        let path = "";
        for (let j = 0; j < linePoints.length; ++j) {
          if (linePoints[j] == "") continue;
          if (linePoints[j].indexOf(",") == -1) continue;
          var latLon = linePoints[j].split(",");
          path += `${latLon[0]},${latLon[1]},0\n`;
        }
        return path;
      }
    }
    return null;
  }

  getCompressedPath() {
    if (this.Points != null) {
      const geohash = require("ngeohash");
      let lineStrings = this.Points;
      //A polyline
      if (lineStrings.indexOf("|") == -1) {
        let linePoints = lineStrings.split(";");
        let path = "";
        for (let j = 0; j < linePoints.length; ++j) {
          if (linePoints[j] == "") continue;
          if (linePoints[j].indexOf(",") == -1) continue;
          var linePoint = linePoints[j].split(",");
          var loc = geohash.decode(linePoint[0]);
          path += "|" + loc.latitude + "," + loc.longitude;
        }
        //console.log("getCompressedPath", path);
        return path;
      }
    }
    return null;
  }

  getCoordinates() {
    let coords = [];
    if (this.Points != null) {
      let lineStrings = this.Points;
      //A polyline
      if (lineStrings.indexOf("|") == -1) {
        let linePoints = lineStrings.split(":");
        //let path = "";
        for (let j = 0; j < linePoints.length; ++j) {
          if (linePoints[j] == "") continue;
          if (linePoints[j].indexOf(",") == -1) continue;
          var latLon = linePoints[j].split(",");
          coords.push({ latitude: parseFloat(latLon[1]), longitude: parseFloat(latLon[0]) });
          //path += "|" + latLon[1] + "," + latLon[0];
        }
        return coords;
      }
    }
    return null;
  }

  getCategories() {
    if (Array.isArray(this.Category)) return this.Category;
    var cats = new Array();
    var cat = this.Category;
    if (cat == null) cats[0] = "None";
    else if (cat == "") cats[0] = "None";
    else if (cat.indexOf("|") == -1) {
      cats[0] = cat;
    } else {
      var scats = cat.split("|");
      for (var j = 0; j < scats.length; ++j) {
        cats.push(scats[j]);
      }
    }
    //console.log(cats);
    return cats;
  }

  contains_Category(cat) {
    var cats = this.getCategories();
    for (var j = 0; j < cats.length; ++j) {
      if (cats[j] == cat) return true;
    }
    return false;
  }

  getGroups() {
    if (Array.isArray(this.Group)) return this.Group;
    var groups = new Array();
    var gp = this.Group;
    if (gp == null) groups[0] = "None";
    else if (gp == "") groups[0] = "None";
    else if (gp.indexOf("|") == -1) {
      groups[0] = gp;
    } else {
      var sgroups = gp.split("|");
      for (var j = 0; j < sgroups.length; ++j) {
        groups.push(sgroups[j]);
      }
    }
    return groups;
  }

  contains_Group(group) {
    var groups = this.getGroups();
    for (var j = 0; j < groups.length; ++j) {
      if (groups[j] == group) return true;
    }
    return false;
  }

  _getCustomIcon(guide, poi_img) {
    const index = guide.custom_icons.findIndex((c) => c.id === poi_img);
    if (index !== -1) {
      const ci = guide.custom_icons[index];
      if (ci.url) return ci.url;
      if (ci.poi_img !== "0") return POI_IMAGES[ci.poi_img].req;
    }
    return default_icon;
  }

  getPOIImage(guide, poi_img) {
    //console.log("getPOIImage", this.Source, isSearchResult(this.Source));
    if (isSearchResult(this.Source) && this.Category.length === 0 && this.Group.length === 0) return search_green;
    if (poi_img != null && typeof poi_img !== "undefined") {
      if (Number.isNaN(parseFloat(poi_img))) return poi_img;
      if (poi_img != "0") {
        if (guide != null) {
          const ci = guide.custom_icons.find((c) => c.id === poi_img);
          if (ci) return ci.url ? ci.url : (ci.poi_img !== "0" ? POI_IMAGES[ci.poi_img].req : default_icon);
        }
        return POI_IMAGES[poi_img].req;
      }
    }
    if (Number.isNaN(parseFloat(this.poi_img))) return this.poi_img;
    if (this.poi_img != "0") {
      if (guide != null) {
        const ci = guide.custom_icons.find((c) => c.id === this.poi_img);
        if (ci) return ci.url ? ci.url : (ci.poi_img !== "0" ? POI_IMAGES[ci.poi_img].req : default_icon);
      }
      return POI_IMAGES[this.poi_img].req;
    }
    if (this.Category.length > 0) {
      for (let i = 0; i < this.Category.length; i++) {
        const category = guide.categoryFromID(this.Category[i]);
        if (category === null || typeof category === "undefined") return POI_IMAGES["1"].req;
        if (typeof category.url !== "undefined") return category.url;
        if (category.poi_img != "0") return POI_IMAGES[category.poi_img].req;
      }
    }
    if (this.Group.length > 0) {
      for (let i = 0; i < this.Group.length; i++) {
        const group = guide.groupFromID(this.Group[i]);
        if (group === null || typeof group === "undefined") return POI_IMAGES["1"].req;
        if (typeof group.url !== "undefined") return group.url;
        if (group.poi_img != "0") return POI_IMAGES[group.poi_img].req;
      }
    }
    return default_icon;
  }

  static getPOIImage(place, guide, poi_img) {
    //console.log("getPOIImage", place.Source, isSearchResult(place.Source));
    if (isSearchResult(place.Source) && place.Category.length === 0 && place.Group.length === 0) return search_green;
    if (poi_img != null && typeof poi_img !== "undefined") {
      if (Number.isNaN(parseFloat(poi_img))) return poi_img;
      if (poi_img != "0") {
        if (guide != null) {
          const ci = guide.custom_icons.find((c) => c.id === poi_img);
          if (ci) return ci.url ? ci.url : (ci.poi_img !== "0" ? POI_IMAGES[ci.poi_img].req : default_icon);
        }
        return POI_IMAGES[poi_img].req;
      }
    }
    if (Number.isNaN(parseFloat(place.poi_img))) return place.poi_img;
    if (place.poi_img != "0") {
      if (guide != null) {
        const ci = guide.custom_icons.find((c) => c.id === place.poi_img);
        if (ci) return ci.url ? ci.url : (ci.poi_img !== "0" ? POI_IMAGES[ci.poi_img].req : default_icon);
      }
      return POI_IMAGES[place.poi_img].req;
    }
    if (place.Category.length > 0) {
      for (let i = 0; i < place.Category.length; i++) {
        const category = guide.categoryFromID(place.Category[i]);
        if (category === null || typeof category === "undefined") return POI_IMAGES["1"].req;
        if (typeof category.url !== "undefined") return category.url;
        if (category.poi_img != "0") return POI_IMAGES[category.poi_img].req;
      }
    }
    if (place.Group.length > 0) {
      for (let i = 0; i < place.Group.length; i++) {
        const group = guide.groupFromID(place.Group[i]);
        if (group === null || typeof group === "undefined") return POI_IMAGES["1"].req;
        if (typeof group.url !== "undefined") return group.url;
        if (group.poi_img != "0") return POI_IMAGES[group.poi_img].req;
      }
    }
    return default_icon;
  }

  // static getGroupPOIImage(group) {
  //   if (group == null) return default_icon;
  //   if (group.poi_img == "0") return default_icon;
  //   if (typeof POI_IMAGES[group.poi_img] == "undefined") return default_icon;
  //   return POI_IMAGES[group.poi_img].req;
  // }

  static getItemPOIImageOLD(item) {
    if (item == null) return default_icon;
    if (item.poi_img == "0") return default_icon;
    if (typeof POI_IMAGES[item.poi_img] == "undefined") return default_icon;
    return POI_IMAGES[item.poi_img].req;
  }

  static getItemPOIImage(item) {
    //console.log("getItemPOIImage", item);
    if (item == null) return null;
    if (typeof item.url !== "undefined") return item.url;
    if (item.poi_img == "0") return null;
    if (typeof POI_IMAGES[item.poi_img] == "undefined") return null;
    return POI_IMAGES[item.poi_img].req;
  }

  static getPlacePOIImage(_poi_img) {
    let poi_img = null;
    if (_poi_img != null && typeof _poi_img !== "undefined") poi_img = _poi_img;
    if (poi_img == "0") return POI_IMAGES["0"].req;
    if (typeof POI_IMAGES[poi_img] !== "undefined") return POI_IMAGES[poi_img].req;
    if (Number.isNaN(parseFloat(poi_img))) return poi_img;
    return POI_IMAGES["0"].req;
  }
  // getPOIImage(guide, _poi_img) {
  //   //console.log("getPOIImage", this.Source, isSearchResult(this.Source));
  //   if (isSearchResult(this.Source)) return search_green;
  //   let poi_img = _poi_img;
  //   if (poi_img === null || typeof poi_img === "undefined") poi_img = this.poi_img;
  //   if (poi_img === "0" && this.Category.length > 0) {
  //     for (let i = 0; i < this.Category.length; i++) {
  //       const category = guide.categoryFromID(this.Category[i]);
  //       if (category != null) {
  //         if (typeof category.url !== "undefined") poi_img = category.url;
  //         else poi_img = category.poi_img;
  //         break;
  //       }
  //     }
  //   }
  //   if (poi_img === "0" && this.Group.length > 0) {
  //     for (let i = 0; i < this.Group.length; i++) {
  //       const group = guide.groupFromID(this.Group[i]);
  //       if (group != null) {
  //         if (typeof group.url !== "undefined") poi_img = group.url;
  //         else poi_img = group.poi_img;
  //         break;
  //       }
  //     }
  //   }
  //   // poi_img is a URL, return it
  //   if (Number.isNaN(parseInt(poi_img))) return poi_img;

  //   const id_num = parseInt(poi_img);
  //   // Standard icon
  //   if (id_num < 5000) return poi_img !== "0" ? POI_IMAGES[poi_img].req : default_icon;
  //   // Custom icon
  //   return this._getCustomIcon(guide, poi_img);
  // }

  // // static getGroupPOIImage(group) {
  // //   if (group == null) return default_icon;
  // //   if (group.poi_img == "0") return default_icon;
  // //   if (typeof POI_IMAGES[group.poi_img] == "undefined") return default_icon;
  // //   return POI_IMAGES[group.poi_img].req;
  // // }

  // static getItemPOIImage(item) {
  //   if (item == null) return null;
  //   if (typeof item.url !== "undefined") return item.url;
  //   if (item.poi_img == "0") return null;

  //   if (Number.isNaN(parseInt(item.poi_img))) return item.poi_img;
  //   const id_num = parseInt(item.poi_img);
  //   // Standard icon
  //   if (id_num < 5000) return item.poi_img !== "0" ? POI_IMAGES[item.poi_img].req : default_icon;
  //   // Custom icon
  //   return this._getCustomIcon(guide, item.poi_img);

  //   if (typeof POI_IMAGES[item.poi_img] == "undefined") return null;
  //   return POI_IMAGES[item.poi_img].req;
  // }

  // static getPlacePOIImage(_poi_img) {
  //   let poi_img = this.poi_img;
  //   if (_poi_img != null && typeof _poi_img !== "undefined") poi_img = _poi_img;
  //   if (poi_img == "0") return POI_IMAGES["0"].req;
  //   if (typeof POI_IMAGES[poi_img] !== "undefined") return POI_IMAGES[poi_img].req;
  //   if (Number.isNaN(parseFloat(poi_img))) return poi_img;
  //   return POI_IMAGES["0"].req;
  // }

  static OPENING_HOURS_DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  // Each day holds zero or more { open, close } periods (e.g. separate lunch
  // and dinner service) plus a closed flag. An empty periods array with
  // closed:false means "no data" (unknown) — never treated as closed.
  static getDefaultOpeningHours() {
    const hours = {};
    Place.OPENING_HOURS_DAYS.forEach((day) => {
      hours[day] = { periods: [], closed: false };
    });
    return hours;
  }

  // FeaturedPlaceImages.json stores hours compactly — { Mon: "09:00-17:00",
  // Tue: "09:00-12:00,14:00-18:00", Sun: "closed" }, only the days with data
  // (scripts/featured-videos/build-featured-place-images.mjs). Returns the
  // full OpeningHours shape; days not listed stay unknown, never closed.
  static openingHoursFromCompact(compact) {
    const hours = Place.getDefaultOpeningHours();
    if (!compact || typeof compact !== "object") return hours;
    Place.OPENING_HOURS_DAYS.forEach((day) => {
      const v = compact[day];
      if (typeof v !== "string" || !v) return;
      if (v === "closed") {
        hours[day] = { periods: [], closed: true };
        return;
      }
      const periods = v.split(",").map((range) => {
        const [open, close] = range.split("-");
        return { open: (open || "").trim(), close: (close || "").trim() };
      }).filter((p) => p.open && p.close);
      if (periods.length) hours[day] = { periods, closed: false };
    });
    return hours;
  }

  // Merges a possibly-partial/older OpeningHours object with defaults so a
  // missing day (e.g. from data saved before this field existed) never
  // crashes isOpenAt — each day is defaulted independently. Also migrates
  // the earlier single-window-per-day shape ({ open, close, closed }) into
  // the current periods-array shape, in case any data was saved with it.
  // Best time of day for a visit ("morning", "afternoon", "sunset",
  // "evening"; none = any time). Schedule.js puts morning places first and
  // sunset/evening ones last when it orders a day. Anything else clears it.
  static BEST_TIMES = ["morning", "afternoon", "sunset", "evening"];
  static setBestTime(place, value) {
    if (Place.BEST_TIMES.includes(value)) place.BestTime = value;
    else delete place.BestTime;
    return place;
  }

  static mergeOpeningHoursDefaults(data) {
    const defaults = Place.getDefaultOpeningHours();
    if (typeof data == "undefined" || data == null) return defaults;
    const merged = {};
    Place.OPENING_HOURS_DAYS.forEach((day) => {
      const dayData = data[day];
      if (typeof dayData == "undefined") {
        merged[day] = defaults[day];
      } else if (Array.isArray(dayData.periods)) {
        merged[day] = { periods: dayData.periods, closed: !!dayData.closed };
      } else if (dayData.open || dayData.close) {
        // Legacy single-window shape.
        merged[day] = { periods: [{ open: dayData.open || "", close: dayData.close || "" }], closed: !!dayData.closed };
      } else {
        merged[day] = { periods: [], closed: !!dayData.closed };
      }
    });
    return merged;
  }

  // dateTime must be a Luxon DateTime already parsed with { zone: "utc" } —
  // this app has no real timezone handling; UTC is treated as local wall-clock
  // time throughout (event Start/End, etc). Never convert dateTime here.
  // Returns true (open), false (known closed), or null (no data — unknown,
  // must never be treated as closed).
  static isOpenAt(place, dateTime) {
    if (!place || !place.OpeningHours || !dateTime) return null;
    const day = Place.OPENING_HOURS_DAYS[dateTime.weekday - 1];
    const hours = place.OpeningHours[day];
    if (!hours) return null;
    if (hours.closed === true) return false;
    if (!Array.isArray(hours.periods) || hours.periods.length === 0) return null;

    const toMinutes = (hhmm) => {
      const [h, m] = hhmm.split(":").map(Number);
      return h * 60 + m;
    };
    const nowMin = dateTime.hour * 60 + dateTime.minute;

    const validPeriods = hours.periods.filter((p) => p.open && p.close);
    if (validPeriods.length === 0) return null;

    return validPeriods.some((p) => {
      const openMin = toMinutes(p.open);
      const closeMin = toMinutes(p.close);
      if (closeMin < openMin) {
        // Crosses midnight (e.g. open 20:00, close 02:00).
        return nowMin >= openMin || nowMin < closeMin;
      }
      return nowMin >= openMin && nowMin < closeMin;
    });
  }

  // Companion to isOpenAt, for callers that need more than a yes/no — used
  // by "Optimize by Location"'s avoid-closed reordering (Schedule.js) to
  // tell "shut all day, no reordering within this day can help" apart from
  // "closed right now but opens again later today, worth a short wait".
  // closedAllDay is only ever true for an explicit hours.closed === true on
  // this exact weekday — the same convention parseOpeningHoursFromNewAPI/
  // mapLegacyOpeningHours use to mark a day with zero periods, so it's a
  // reliable signal, not a guess. minutesUntilOpen is null when already
  // open, closed all day, or every period for today has already passed.
  static openingStatusAt(place, dateTime) {
    if (!place || !place.OpeningHours || !dateTime) return { closedAllDay: false, minutesUntilOpen: null };
    const day = Place.OPENING_HOURS_DAYS[dateTime.weekday - 1];
    const hours = place.OpeningHours[day];
    if (!hours) return { closedAllDay: false, minutesUntilOpen: null };
    if (hours.closed === true) return { closedAllDay: true, minutesUntilOpen: null };

    const validPeriods = Array.isArray(hours.periods) ? hours.periods.filter((p) => p.open && p.close) : [];
    if (validPeriods.length === 0) return { closedAllDay: false, minutesUntilOpen: null };

    const toMinutes = (hhmm) => {
      const [h, m] = hhmm.split(":").map(Number);
      return h * 60 + m;
    };
    const nowMin = dateTime.hour * 60 + dateTime.minute;

    const alreadyOpen = validPeriods.some((p) => {
      const openMin = toMinutes(p.open);
      const closeMin = toMinutes(p.close);
      if (closeMin < openMin) return nowMin >= openMin || nowMin < closeMin;
      return nowMin >= openMin && nowMin < closeMin;
    });
    if (alreadyOpen) return { closedAllDay: false, minutesUntilOpen: 0 };

    const upcoming = validPeriods
      .map((p) => toMinutes(p.open))
      .filter((openMin) => openMin > nowMin)
      .sort((a, b) => a - b);
    if (upcoming.length === 0) return { closedAllDay: false, minutesUntilOpen: null };
    return { closedAllDay: false, minutesUntilOpen: upcoming[0] - nowMin };
  }

  // Companion to isOpenAt/openingStatusAt — when the place IS open at
  // dateTime, how many minutes until the period covering dateTime closes.
  // Used to flag an event that starts fine but runs past closing, which
  // isOpenAt(place, event.Start) alone can never catch since it only looks
  // at the start instant. Returns null if not open at dateTime (caller
  // should have already checked that) or there's no hours data.
  static minutesUntilCloseAt(place, dateTime) {
    if (!place || !place.OpeningHours || !dateTime) return null;
    const day = Place.OPENING_HOURS_DAYS[dateTime.weekday - 1];
    const hours = place.OpeningHours[day];
    if (!hours || hours.closed === true) return null;
    const validPeriods = Array.isArray(hours.periods) ? hours.periods.filter((p) => p.open && p.close) : [];
    if (validPeriods.length === 0) return null;

    const toMinutes = (hhmm) => {
      const [h, m] = hhmm.split(":").map(Number);
      return h * 60 + m;
    };
    const nowMin = dateTime.hour * 60 + dateTime.minute;

    for (const p of validPeriods) {
      const openMin = toMinutes(p.open);
      const closeMin = toMinutes(p.close);
      // The app's own canonical "open 24 hours" representation (see
      // GooglePlaces.js's parsing, e.g. a Google result whose only period
      // opens at 00:00 with no close at all) is normalized to this exact
      // 00:00–23:59 period, not a real near-midnight closing time. Treating
      // it as a real close produces a misleading "Open until 23:59" for a
      // place that's genuinely always open (found via Galleria Vittorio
      // Emanuele II, a 24-hour shopping arcade, 2026-09-30) — return null
      // (no meaningful close time) instead, same as "no hours data at all".
      if (openMin === 0 && closeMin === 1439) return null;
      const spansMidnight = closeMin < openMin;
      const isCurrent = spansMidnight ? (nowMin >= openMin || nowMin < closeMin) : (nowMin >= openMin && nowMin < closeMin);
      if (isCurrent) return spansMidnight ? closeMin + 1440 - nowMin : closeMin - nowMin;
    }
    return null;
  }

  // Resolves event.Places (comma-separated place IDs) and flags the event if
  // ANY resolved place is known-closed at event.Start, OR (when every place
  // is open at the start) any resolved place's current period closes before
  // event.End. Returns { status, closedAllDay, minutesUntilOpen,
  // minutesUntilClose } — status is "closed" | "closes_during" | "open" |
  // "unknown". closedAllDay/minutesUntilOpen are only meaningful for
  // "closed"; minutesUntilClose only for "closes_during". "closed" always
  // takes priority over "closes_during" across the event's places — a place
  // not open yet is the more urgent problem to flag. closedAllDay
  // distinguishes "shut this whole weekday" (moving days is the only fix)
  // from an ordinary wrong-time conflict; the minutes fields let a caller
  // say WHY — "opens at 2" / "closes at 6" — instead of just "closed", so a
  // schedule reviewer doesn't have to open the place's own hours to find
  // that out.
  static getOpeningHoursConflict(event, placesModel) {
    if (!event || !event.Places || !placesModel) return { status: "unknown" };
    const startTime = DateTime.fromISO(event.Start, { zone: "utc" });
    const endTime = DateTime.fromISO(event.End, { zone: "utc" });
    const placeIds = event.Places.split(",").map((id) => id.trim()).filter(Boolean);
    let sawKnown = false;
    let closesDuringCandidate = null;
    for (const id of placeIds) {
      const place = placesModel.getPlace(id);
      const open = Place.isOpenAt(place, startTime);
      if (open === false) {
        const { closedAllDay, minutesUntilOpen } = Place.openingStatusAt(place, startTime);
        return { status: "closed", closedAllDay, minutesUntilOpen };
      }
      if (open === true) {
        sawKnown = true;
        if (!closesDuringCandidate && endTime.isValid) {
          const minutesUntilClose = Place.minutesUntilCloseAt(place, startTime);
          if (minutesUntilClose != null && endTime.diff(startTime, "minutes").minutes > minutesUntilClose) {
            closesDuringCandidate = { status: "closes_during", minutesUntilClose };
          }
        }
      }
    }
    if (closesDuringCandidate) return closesDuringCandidate;
    return { status: sawKnown ? "open" : "unknown" };
  }
}

export var Place_Source = {
  GUIDE: 0,
  USER: 1,
  SEARCH: 2,
  ATTRACTION: 3,
  WIKIPEDIA: 4,
  YOUTUBE: 5,
  PANORAMIO: 6,
  OPENTRIPMAP: 7,
  GOOGLEPLACES: 8,
  FLICKR: 9,
  PHOTO_SEARCH: 10,
  FEATURED: 11,
};
